/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '../typography/Typography';

const Eyebrow = ({ ornament, title }) => {
  if (!ornament && !title) return null;
  return (
    <div className="sui-flex sui-text-brand sui-grow sui-items-start">
      {ornament && (
        <div className="sui-mr-2">
          {ornament}
        </div>
      )}
      <div className="sui-mt-2px sui-line-clamp-1">
        <Typography color="brand" weight="bold" height="tight">{title}</Typography>
      </div>
    </div>
  );
};

Eyebrow.propTypes = {
  /**
   * The contents of the eyebrow.
   */
  title: PropTypes.string,
  /**
   * The leading ornament within the eyebrow.
   */
  ornament: PropTypes.node
};

export { Eyebrow };